import { palette, shape, typography } from "@src/core/styles";
import styled from "styled-components";

export const QuestionsWrapper = styled.div`
  & button {
    text-transform: none !important;
  }
`;

export const QuestionsInner = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 48px;
  margin: 36px 0;
`;

export const HelperBlock = styled.div`
  border: ${palette.border.grey};
  border-radius: ${shape.rounding.L};
  padding: 16px 24px;
  max-width: 312px;

  & svg {
    margin-bottom: 16px;
  }

  & a {
    color: ${palette.colors.link};
    &:hover {
      color: ${palette.colors.green_base};
    }
  }

  & button {
    width: 100%;
    margin-top: 16px;
    text-transform: none;
  }
`;

export const AccordionGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & .MuiButtonBase-root.MuiAccordionSummary-root {
    background-color: ${palette.colors.surface};
    border-radius: ${shape.rounding.L};
  }
  & .MuiPaper-root.MuiAccordion-root {
    border-radius: ${shape.rounding.L};
    box-shadow: none;
    &::before {
      opacity: 0;
    }
  }
  & .MuiPaper-root.MuiAccordion-root:last-of-type {
    border-bottom-left-radius: ${shape.rounding.L};
    border-bottom-right-radius: ${shape.rounding.L};
  }
  & .MuiPaper-root.MuiAccordion-root:first-of-type {
    border-top-left-radius: ${shape.rounding.L};
    border-top-right-radius: ${shape.rounding.L};
  }
  & .MuiPaper-root.MuiAccordion-root {
    background-color: ${palette.colors.surface};
  }
  & .MuiAccordionSummary-content.Mui-expanded {
    margin: 16px 0;
  }
  & .MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded {
    min-height: 48px;
  }
`;

export const AccordionTitle = styled.div`
  ${typography.title_medium};
`;

export const AccordionBody = styled.div`
  ${typography.body_large_regular};
  color: ${palette.colors.onsurface_variant};
`;
